// @ts-nocheck
import { get, post, patch, deleteRequest } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL_SYNC || 'http://localhost:32768';
const BASE_URL = `${API_URL}/api/v1/DepositoNotaFiscal`;
const TABELA_PRECO_URL = `${API_URL}/api/v1/DepositoTabelaPreco`;
const TABELA_PRECO_CLIENTE_URL = `${API_URL}/api/v1/DepositoTabelaPrecoCliente`;
const DEPOSITO_CLIENTE_URL = `${API_URL}/api/v1/DepositoCliente`;
const DEPOSITO_ARMAZEM_URL = `${API_URL}/api/v1/DepositoArmazem`;
const DEPOSITO_ENDERECO_URL = `${API_URL}/api/v1/DepositoEndereco`;
const DEPOSITO_ARMAZENAGEM_LOCAL_URL = `${API_URL}/api/v1/DepositoArmazenagemLocal`;
const COBRANCA_ARMAZENAGEM_URL = `${BASE_URL}/cobranca-armazenagem`;
/**
 * Lista notas fiscais do deposito com filtros e paginacao
 * @param {Record<string, any>} [filters={}] - Filtros para a busca
 * @returns {Promise<Object>} Resposta com lista de notas fiscais
 */
export const getDepositoNotasFiscais = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${BASE_URL}?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Lista cobranças agregadas do depósito com filtros e paginação
 * @param {Record<string, any>} [filters={}] - Filtros para a busca
 * @returns {Promise<Object>} Resposta com lista de cobranças
 */
export const getDepositoCobrancas = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${BASE_URL}/cobrancas?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Retorna o resumo de pendencias das notas fiscais do deposito
 * @param {Record<string, any>} [filters={}] - Filtros base para o resumo
 * @returns {Promise<Object>} Resumo das pendencias
 */
export const getDepositoNotaFiscalResumoPendencias = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (key === 'PendenciaHeader') {
            return;
        }
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${BASE_URL}/resumo-pendencias?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Lista anexos de notas fiscais do deposito com filtros e paginacao
 * @param {Record<string, any>} [filters={}] - Filtros para a busca
 * @returns {Promise<Object>} Resposta com lista de anexos
 */
export const getDepositoNotaFiscalAnexos = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${BASE_URL}/anexos?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Lista tabelas de preco do deposito com filtros e paginacao
 * @param {Record<string, any>} [filters={}] - Filtros para a busca
 * @returns {Promise<Object>} Resposta com lista de tabelas
 */
export const getDepositoTabelaPrecos = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${TABELA_PRECO_URL}?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca tabela de preco do deposito por id
 * @param {number} id
 * @returns {Promise<Object>} Tabela de preco encontrada
 */
export const getDepositoTabelaPrecoById = async (id) => {
    const response = await get(`${TABELA_PRECO_URL}/${id}`);
    return response?.data || response;
};
/**
 * Cria tabela de preco do deposito
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Tabela criada
 */
export const createDepositoTabelaPreco = async (payload) => {
    const response = await post(`${TABELA_PRECO_URL}`, payload);
    return response?.data || response;
};
/**
 * Atualiza tabela de preco do deposito por id
 * @param {number} id
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Tabela atualizada
 */
export const updateDepositoTabelaPreco = async (id, payload) => {
    const response = await patch(`${TABELA_PRECO_URL}/${id}`, payload);
    return response?.data || response;
};
/**
 * Aplica tabela de preco em massa nas notas elegiveis
 * @param {number} id
 * @returns {Promise<Object>} Resultado da aplicacao
 */
export const applyDepositoTabelaPreco = async (id) => {
    const response = await post(`${TABELA_PRECO_URL}/${id}/aplicar`, {});
    return response?.data || response;
};
/**
 * Lista associacoes de tabela preco cliente do deposito com filtros e paginacao
 * @param {Record<string, any>} [filters={}] - Filtros para a busca
 * @returns {Promise<Object>} Resposta com lista de associacoes
 */
export const getDepositoTabelaPrecoClientes = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${TABELA_PRECO_CLIENTE_URL}?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca associacao de tabela preco cliente por id
 * @param {number} id
 * @returns {Promise<Object>} Associacao encontrada
 */
export const getDepositoTabelaPrecoClienteById = async (id) => {
    const response = await getDepositoTabelaPrecoClientes({
        Id: id,
        PaginaAtual: 1,
        QuantidadePorPagina: 1
    });
    const data = response?.data || response || {};
    const registros = Array.isArray(data.registros) ? data.registros : [];
    return registros[0] || null;
};
/**
 * Cria associacao de tabela preco cliente
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Associacao criada
 */
export const createDepositoTabelaPrecoCliente = async (payload) => {
    const response = await post(`${TABELA_PRECO_CLIENTE_URL}`, payload);
    return response?.data || response;
};
/**
 * Atualiza associacao de tabela preco cliente por id
 * @param {number} id
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Associacao atualizada
 */
export const updateDepositoTabelaPrecoCliente = async (id, payload) => {
    const response = await patch(`${TABELA_PRECO_CLIENTE_URL}/${id}`, payload);
    return response?.data || response;
};
/**
 * Remove associacao de tabela preco cliente por id
 * @param {number} id
 * @returns {Promise<void>} Resultado
 */
export const deleteDepositoTabelaPrecoCliente = async (id) => {
    const response = await deleteRequest(`${TABELA_PRECO_CLIENTE_URL}/${id}`);
    return response?.data || response;
};
/**
 * Lista clientes do deposito com filtros e paginacao
 * @param {Record<string, any>} [filters={}] - Filtros para a busca
 * @returns {Promise<Object>} Resposta com lista de clientes
 */
export const getDepositoClientes = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${DEPOSITO_CLIENTE_URL}?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca cliente do deposito por id
 * @param {number} id
 * @returns {Promise<Object>} Cliente encontrado
 */
export const getDepositoClienteById = async (id) => {
    const response = await getDepositoClientes({
        Id: id,
        PaginaAtual: 1,
        QuantidadePorPagina: 1
    });
    const data = response?.data || response || {};
    const registros = Array.isArray(data.registros) ? data.registros : [];
    return registros[0] || null;
};
/**
 * Cria cliente do deposito
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Cliente criado
 */
export const createDepositoCliente = async (payload) => {
    const response = await post(`${DEPOSITO_CLIENTE_URL}`, payload);
    return response?.data || response;
};
/**
 * Atualiza cliente do deposito por id
 * @param {number} id
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Cliente atualizado
 */
export const updateDepositoCliente = async (id, payload) => {
    const response = await patch(`${DEPOSITO_CLIENTE_URL}/${id}`, payload);
    return response?.data || response;
};
/**
 * Remove cliente do deposito por id
 * @param {number} id
 * @returns {Promise<void>} Resultado
 */
export const deleteDepositoCliente = async (id) => {
    const response = await deleteRequest(`${DEPOSITO_CLIENTE_URL}/${id}`);
    return response?.data || response;
};
/**
 * Busca nome do cliente pelo CNPJ (Pessoa -> DepositoCliente)
 * @param {string} cnpj
 * @returns {Promise<{nomeCliente: string | null}>}
 */
export const getNomeClientePorCnpj = async (cnpj) => {
    const queryParams = new URLSearchParams();
    if (cnpj) {
        queryParams.append('cnpj', String(cnpj));
    }
    const url = `${DEPOSITO_CLIENTE_URL}/nome?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Cria uma nota fiscal do deposito
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Nota fiscal criada
 */
export const createDepositoNotaFiscal = async (payload) => {
    const response = await post(`${BASE_URL}`, payload);
    return response?.data || response;
};
/**
 * Busca uma nota fiscal do deposito por id
 * @param {number} id
 * @returns {Promise<Object>} Nota fiscal encontrada
 */
export const getDepositoNotaFiscalById = async (id) => {
    const response = await get(`${BASE_URL}/${id}`);
    return response?.data || response;
};
/**
 * Consulta dados da NF-e no MultiSOAP pela chave de acesso (44 digitos)
 * @param {string} chaveNFe
 * @returns {Promise<Object>} Dados extraidos da NF-e
 */
export const consultarDepositoNotaFiscalPorChave = async (chaveNFe) => {
    const chave = encodeURIComponent(chaveNFe);
    const response = await get(`${BASE_URL}/consulta-nfe?chaveNFe=${chave}`);
    return response?.data || response;
};
/**
 * Consulta canhoto da NF-e no MultiSOAP pelo id da nota de deposito (ChaveNFe lida do banco)
 * @param {number} id
 * @returns {Promise<Object>} Arquivo base64 e extensao
 */
export const consultarDepositoCanhotoPorNotaId = async (id) => {
    const response = await get(`${BASE_URL}/consulta-canhoto?id=${id}`);
    return response?.data || response;
};
/**
 * Lista auditoria de uma nota fiscal do deposito
 * @param {number} id
 * @param {Record<string, any>} [filters={}]
 * @returns {Promise<Object>} Auditoria paginada
 */
export const getDepositoNotaFiscalAuditoria = async (id, filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const suffix = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const response = await get(`${BASE_URL}/${id}/auditoria${suffix}`);
    return response?.data || response || {};
};
/**
 * Lista locais macro de armazenagem do deposito
 * @returns {Promise<Array>} Lista de locais
 */
export const getDepositoArmazenagemLocais = async () => {
    const response = await get(`${DEPOSITO_ARMAZENAGEM_LOCAL_URL}`);
    return response?.data || response || [];
};
/**
 * Lista armazens do deposito com filtros e paginacao
 * @param {Record<string, any>} [filters={}]
 * @returns {Promise<Object>}
 */
export const getDepositoArmazens = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${DEPOSITO_ARMAZEM_URL}?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca armazem do deposito por id
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getDepositoArmazemById = async (id) => {
    const response = await get(`${DEPOSITO_ARMAZEM_URL}/${id}`);
    return response?.data || response;
};
/**
 * Cria armazem do deposito
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>}
 */
export const createDepositoArmazem = async (payload) => {
    const response = await post(`${DEPOSITO_ARMAZEM_URL}`, payload);
    return response?.data || response;
};
/**
 * Atualiza armazem do deposito por id
 * @param {number} id
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>}
 */
export const updateDepositoArmazem = async (id, payload) => {
    const response = await patch(`${DEPOSITO_ARMAZEM_URL}/${id}`, payload);
    return response?.data || response;
};
/**
 * Lista enderecos do deposito com filtros e paginacao
 * @param {Record<string, any>} [filters={}]
 * @returns {Promise<Object>}
 */
export const getDepositoEnderecos = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${DEPOSITO_ENDERECO_URL}?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca endereco do deposito por id
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getDepositoEnderecoById = async (id) => {
    const response = await get(`${DEPOSITO_ENDERECO_URL}/${id}`);
    return response?.data || response;
};
/**
 * Cria endereco do deposito
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>}
 */
export const createDepositoEndereco = async (payload) => {
    const response = await post(`${DEPOSITO_ENDERECO_URL}`, payload);
    return response?.data || response;
};
/**
 * Atualiza endereco do deposito por id
 * @param {number} id
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>}
 */
export const updateDepositoEndereco = async (id, payload) => {
    const response = await patch(`${DEPOSITO_ENDERECO_URL}/${id}`, payload);
    return response?.data || response;
};
/**
 * Remove endereco do deposito por id
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteDepositoEndereco = async (id) => {
    const response = await deleteRequest(`${DEPOSITO_ENDERECO_URL}/${id}`);
    return response?.data || response;
};
/**
 * Remove enderecos do deposito em lote
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>}
 */
export const deleteDepositoEnderecoEmLote = async (payload) => {
    const response = await post(`${DEPOSITO_ENDERECO_URL}/excluir-lote`, payload);
    return response?.data || response;
};
/**
 * Cria enderecos em lote no armazem informado
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>}
 */
export const criarLayoutDepositoEndereco = async (payload) => {
    const response = await post(`${DEPOSITO_ENDERECO_URL}/criar-layout`, payload);
    return response?.data || response;
};
/**
 * Move todas as notas de um endereco para outro
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>}
 */
export const movimentarDepositoEnderecoNotas = async (payload) => {
    const response = await post(`${DEPOSITO_ENDERECO_URL}/movimentar-notas`, payload);
    return response?.data || response;
};
/**
 * Lista historico de movimentacoes entre enderecos
 * @param {Record<string, any>} [filters={}]
 * @returns {Promise<Object>}
 */
export const getDepositoEnderecoMovimentacoes = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${DEPOSITO_ENDERECO_URL}/movimentacoes?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Lista auditoria geral de notas fiscais do deposito
 * @param {Record<string, any>} [filters={}]
 * @returns {Promise<Object>} Auditoria paginada
 */
export const getDepositoNotasFiscaisAuditoria = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const suffix = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const response = await get(`${BASE_URL}/auditoria${suffix}`);
    return response?.data || response || {};
};
/**
 * Lista auditoria geral de tabelas de preco do deposito
 * @param {Record<string, any>} [filters={}]
 * @returns {Promise<Object>} Auditoria paginada
 */
export const getDepositoTabelasPrecoAuditoria = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const suffix = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const response = await get(`${TABELA_PRECO_URL}/auditoria${suffix}`);
    return response?.data || response || {};
};
/**
 * Atualiza uma nota fiscal do deposito por id
 * @param {number} id
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Nota fiscal atualizada
 */
export const updateDepositoNotaFiscal = async (id, payload) => {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
        throw new Error('Payload invalido para atualizar DepositoNotaFiscal.');
    }
    const response = await patch(`${BASE_URL}/${id}`, payload);
    return response?.data || response;
};
/**
 * Cadastra divergencia para uma nota fiscal do deposito
 * @param {number} id
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Nota fiscal atualizada
 */
export const cadastrarDivergenciaDepositoNotaFiscal = async (id, payload) => {
    const response = await post(`${BASE_URL}/${id}/divergencia`, payload);
    return response?.data || response;
};
/**
 * Envia anexos para uma nota fiscal do deposito
 * @param {number} id
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Resultado do envio
 */
export const enviarAnexosDepositoNotaFiscal = async (id, payload) => {
    const response = await post(`${BASE_URL}/${id}/anexos`, payload);
    return response?.data || response;
};
/**
 * Envia canhoto para uma nota fiscal do deposito
 * @param {number} id
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Nota fiscal atualizada
 */
export const enviarCanhotoDepositoNotaFiscal = async (id, payload) => {
    const response = await post(`${BASE_URL}/${id}/canhoto`, payload);
    return response?.data || response;
};
/**
 * Finaliza uma nota fiscal do deposito
 * @param {number} id
 * @returns {Promise<Object>} Nota fiscal atualizada
 */
export const finalizarDepositoNotaFiscal = async (id) => {
    const response = await post(`${BASE_URL}/${id}/finalizar`, {});
    return response?.data || response;
};
/**
 * Finaliza notas fiscais do deposito em lote
 * @param {number[]} ids
 * @returns {Promise<Object>} Resumo da finalizacao
 */
export const finalizarDepositoNotaFiscalEmLote = async (ids) => {
    const response = await post(`${BASE_URL}/finalizar-lote`, { Ids: ids });
    return response?.data || response;
};
/**
 * Altera notas fiscais do deposito em lote
 * @param {Record<string, any>} payload
 * @returns {Promise<Object>} Resumo da alteracao
 */
export const alterarDepositoNotaFiscalEmLote = async (payload) => {
    const response = await post(`${BASE_URL}/alterar-lote`, payload);
    return response?.data || response;
};
/**
 * Exporta relatorio de pendencias do deposito
 * @param {Record<string, any>} payload
 * @returns {Promise<string>} HTML do relatorio
 */
export const exportarPendenciasDeposito = async (payload) => {
    const response = await post(`${BASE_URL}/relatorio-pendencias`, payload, { responseType: 'text' });
    return response?.data || response;
};
/**
 * Retorna a documentacao HTML do modulo de deposito
 * @returns {Promise<string>} HTML da documentacao
 */
export const obterDocumentacaoDepositoNotas = async () => {
    const response = await get(`${BASE_URL}/documentacao`, { responseType: 'text' });
    return response?.data || response;
};
/**
 * Exporta layout de importacao de notas fiscais do deposito
 * @returns {Promise<Blob>} Arquivo modelo
 */
export const exportarLayoutImportacaoDepositoNotas = async () => {
    const response = await get(`${BASE_URL}/importacao/layout`, { responseType: 'blob' });
    return response?.data || response;
};
/**
 * Importa notas fiscais do deposito via Excel
 * @param {FormData} formData
 * @returns {Promise<Object>} Resultado da importacao
 */
export const importarDepositoNotasFiscais = async (formData) => {
    const response = await post(`${BASE_URL}/importacao`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response?.data || response;
};
/**
 * Calcula cobranca de paletizacao
 * @param {number[]} ids
 * @returns {Promise<Object>} Calculo da cobranca
 */
export const calcularCobrancaPaletizacao = async (ids) => {
    const response = await post(`${BASE_URL}/cobranca-paletizacao/calcular`, { Ids: ids });
    return response?.data || response;
};
/**
 * Registra cobranca de paletizacao
 * @param {number[]} ids
 * @param {number} valorTotal
 * @returns {Promise<Object>} Resultado
 */
export const registrarCobrancaPaletizacao = async (ids, valorTotal, numeroPedidoEmbarcador, observacoes) => {
    const payload = { Ids: ids, ValorTotal: valorTotal };
    if (numeroPedidoEmbarcador) {
        payload.NumeroPedidoEmbarcador = numeroPedidoEmbarcador;
    }
    if (observacoes !== undefined) {
        payload.Observacoes = observacoes;
    }
    const response = await post(`${BASE_URL}/cobranca-paletizacao/registrar`, payload);
    return response?.data || response;
};
/**
 * Cancela cobranca de paletizacao por protocolo
 * @param {string} protocolo
 * @returns {Promise<Object>} Resultado
 */
export const cancelarCobrancaPaletizacao = async (protocolo) => {
    const response = await post(`${BASE_URL}/cobranca-paletizacao/protocolo/${encodeURIComponent(protocolo)}/reverter`, {});
    return response?.data || response;
};
/**
 * Calcula cobranca de etiquetagem
 * @param {number[]} ids
 * @returns {Promise<Object>} Calculo da cobranca
 */
export const calcularCobrancaEtiquetagem = async (ids) => {
    const response = await post(`${BASE_URL}/cobranca-etiquetagem/calcular`, { Ids: ids });
    return response?.data || response;
};
/**
 * Registra cobranca de etiquetagem
 * @param {number[]} ids
 * @param {number} valorTotal
 * @returns {Promise<Object>} Resultado
 */
export const registrarCobrancaEtiquetagem = async (ids, valorTotal, numeroPedidoEmbarcador, observacoes) => {
    const payload = { Ids: ids, ValorTotal: valorTotal };
    if (numeroPedidoEmbarcador) {
        payload.NumeroPedidoEmbarcador = numeroPedidoEmbarcador;
    }
    if (observacoes !== undefined) {
        payload.Observacoes = observacoes;
    }
    const response = await post(`${BASE_URL}/cobranca-etiquetagem/registrar`, payload);
    return response?.data || response;
};
/**
 * Cancela cobranca de etiquetagem por protocolo
 * @param {string} protocolo
 * @returns {Promise<Object>} Resultado
 */
export const cancelarCobrancaEtiquetagem = async (protocolo) => {
    const response = await post(`${BASE_URL}/cobranca-etiquetagem/protocolo/${encodeURIComponent(protocolo)}/reverter`, {});
    return response?.data || response;
};
/**
 * Calcula cobranca de armazenagem
 * @param {number[]} ids
 * @returns {Promise<Object>} Calculo da cobranca
 */
export const calcularCobrancaArmazenagem = async (ids, dataCobranca) => {
    const payload = { Ids: ids };
    if (dataCobranca !== undefined) {
        payload.DataCobranca = dataCobranca;
    }
    const response = await post(`${BASE_URL}/cobranca-armazenagem/calcular`, payload);
    return response?.data || response;
};
/**
 * Registra cobranca de armazenagem
 * @param {number[]} ids
 * @param {number} valorTotal
 * @returns {Promise<Object>} Resultado
 */
export const registrarCobrancaArmazenagem = async (ids, valorTotal, numeroPedidoEmbarcador, observacoes, dataCobranca) => {
    const payload = { Ids: ids, ValorTotal: valorTotal };
    if (numeroPedidoEmbarcador) {
        payload.NumeroPedidoEmbarcador = numeroPedidoEmbarcador;
    }
    if (observacoes !== undefined) {
        payload.Observacoes = observacoes;
    }
    if (dataCobranca !== undefined) {
        payload.DataCobranca = dataCobranca;
    }
    const response = await post(`${BASE_URL}/cobranca-armazenagem/registrar`, payload);
    return response?.data || response;
};
/**
 * Cancela cobranca de armazenagem por protocolo
 * @param {string} protocolo
 * @returns {Promise<Object>} Resultado
 */
export const cancelarCobrancaArmazenagem = async (protocolo) => {
    const response = await post(`${BASE_URL}/cobranca-armazenagem/protocolo/${encodeURIComponent(protocolo)}/reverter`, {});
    return response?.data || response;
};
/**
 * Calcula cobrança avulsa
 * @param {number[]} ids
 * @returns {Promise<Object>} Calculo da cobrança
 */
export const calcularCobrancaAvulsa = async (ids) => {
    const response = await post(`${BASE_URL}/cobranca-avulsa/calcular`, { Ids: ids });
    return response?.data || response;
};
/**
 * Registra cobrança avulsa
 * @param {number[]} idsDepositoNotaFiscal
 * @param {number} valorTotal
 * @param {string} tipo
 * @param {string | undefined} numeroPedidoEmbarcador
 * @param {string | undefined} observacoes
 * @returns {Promise<Object>} Resultado
 */
export const registrarCobrancaAvulsa = async (idsDepositoNotaFiscal, valorTotal, tipo, numeroPedidoEmbarcador, observacoes) => {
    const payload = {
        IdsDepositoNotaFiscal: idsDepositoNotaFiscal,
        ValorTotal: valorTotal,
        Tipo: tipo
    };
    if (numeroPedidoEmbarcador) {
        payload.NumeroPedidoEmbarcador = numeroPedidoEmbarcador;
    }
    if (observacoes !== undefined) {
        payload.Observacoes = observacoes;
    }
    const response = await post(`${BASE_URL}/cobranca-avulsa/registrar`, payload);
    return response?.data || response;
};
/**
 * Cancela cobrança avulsa por protocolo
 * @param {string} protocolo
 * @returns {Promise<Object>} Resultado
 */
export const cancelarCobrancaAvulsa = async (protocolo) => {
    const response = await post(`${BASE_URL}/cobranca-avulsa/protocolo/${encodeURIComponent(protocolo)}/reverter`, {});
    return response?.data || response;
};
/**
 * Lista cobranças avulsas de uma nota fiscal
 * @param {number} idDepositoNotaFiscal
 * @param {Record<string, any>} [filters={}]
 * @returns {Promise<Object>} Resposta com lista de cobranças
 */
export const getDepositoCobrancasAvulsas = async (idDepositoNotaFiscal, filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const suffix = queryParams.toString();
    const url = `${BASE_URL}/${idDepositoNotaFiscal}/cobrancas-avulsas${suffix ? `?${suffix}` : ''}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Lista cobrancas de armazenagem com filtros e paginacao
 * @param {Record<string, any>} [filters={}] - Filtros para a busca
 * @returns {Promise<Object>} Resposta com lista de cobrancas
 */
export const getDepositoCobrancasArmazenagem = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${COBRANCA_ARMAZENAGEM_URL}?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
